module.exports = __webpack_public_path__ + "static/media/icon-success.1ed13e33.svg";